import ApplicationController from './application_controller'

export default class extends ApplicationController {
  static targets = ['name']

  connect() {
    super.connect()
  }

  formatName(event) {
    event.preventDefault()
    this.name = this.name.replace(/ /g, '_')
  }

  set name(value) {
    this.nameTarget.value = value
  }

  get name() {
    return this.nameTarget.value
  }
}
